self["MonacoEnvironment"] = (function (paths) {
      function stripTrailingSlash(str) {
        return str.replace(/\/$/, '');
      }
      return {
        globalAPI: false,
        getWorkerUrl: function (moduleId, label) {
          var pathPrefix = typeof __webpack_public_path__ === 'string' ? __webpack_public_path__ : "https://d3i1l7uruc4wtt.cloudfront.net/";
          var result = (pathPrefix ? stripTrailingSlash(pathPrefix) + '/' : '') + paths[label];
          if (/^((http:)|(https:)|(file:)|(\/\/))/.test(result)) {
            var currentUrl = String(window.location);
            var currentOrigin = currentUrl.substr(0, currentUrl.length - window.location.hash.length - window.location.search.length - window.location.pathname.length);
            if (result.substring(0, currentOrigin.length) !== currentOrigin) {
              if(/^(\/\/)/.test(result)) {
                result = window.location.protocol + result
              }
              var js = '/*' + label + '*/importScripts("' + result + '");';
              var blob = new Blob([js], { type: 'application/javascript' });
              return URL.createObjectURL(blob);
            }
          }
          return result;
        }
      };
    })({
  "editorWorkerService": "editor.worker.js",
  "html": "html.worker.js",
  "css": "css.worker.js",
  "less": "css.worker.js",
  "scss": "css.worker.js",
  "handlebars": "html.worker.js",
  "razor": "html.worker.js"
});
import "./standalone/browser/accessibilityHelp/accessibilityHelp.js";
import "./browser/controller/coreCommands.js";
import "./contrib/folding/folding.js";
import "./contrib/format/formatActions.js";
import "./contrib/find/findController.js";
import "./contrib/indentation/indentation.js";
import "./contrib/bracketMatching/bracketMatching.js";
import "./contrib/snippet/snippetController2.js";
import "./contrib/suggest/suggestController.js";
import "./contrib/documentSymbols/documentSymbols.js";

import * as monaco from "!!./editor.api.js";
export * from "!!./editor.api.js";
export default monaco;
		
import "../basic-languages/html/html.contribution.js";
import "../language/html/monaco.contribution.js";
import "../basic-languages/css/css.contribution.js";
import "../language/css/monaco.contribution.js";
import "../basic-languages/javascript/javascript.contribution.js";